import { generateClient } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import LocalGraphQLClient from './LocalGraphQLClient';

const amplifyClient = generateClient();
const isLocalMode = process.env.REACT_APP_LOCAL_AUTH === 'true';
const localWsUrl = process.env.REACT_APP_LOCAL_GQL_WS_URL;
let localClient = null;
let localClientReady = false;

if (isLocalMode && localWsUrl) {
  console.log('[SUBSCRIPTION] Initializing local client with URL:', localWsUrl);
  localClient = new LocalGraphQLClient(localWsUrl);
  localClient.connect().then(() => {
    localClientReady = true;
    console.log('[SUBSCRIPTION] Local client ready');
  }).catch(err => {
    console.error('[SUBSCRIPTION] Local client failed:', err);
    localClient = null;
  });
} else {
  console.log('[SUBSCRIPTION] Local mode:', isLocalMode, 'Local WS URL:', localWsUrl);
}

export async function createSubscription(query, variables, onData, onError) {
  if (isLocalMode && localClient && localClientReady) {
    console.log('[SUBSCRIPTION] Using local client');
    return localClient.subscribe(query, variables, onData);
  }
  
  console.log('[SUBSCRIPTION] Using Amplify client');
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  return amplifyClient.graphql({ query, variables, authToken }).subscribe({
    next: ({ data }) => onData(data),
    error: (error) => onError ? onError(error) : console.warn('[SUBSCRIPTION] Error:', error)
  });
}
